import React, { createContext } from 'react';
import { useLocalStorage } from '@BUP/hooks';

export const LoginLanguageContext = createContext();

export const LoginLanguageContextProvider = ({ children }) => {
  const lang = navigator?.language?.toLowerCase();

  //   const [language, setLanguage] = useState(lang);
  const [language, setLanguage] = useLocalStorage(lang, lang);
  const selectedEnglishLanguage = language?.includes('en');

  return (
    <LoginLanguageContext.Provider
      value={{
        selectedEnglishLanguage,
        setLanguage,
      }}
    >
      {children}
    </LoginLanguageContext.Provider>
  );
};
